import { render } from "./Pagination.vue?vue&type=template&id=090c10bf"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=090c10bf&lang=css"
script.render = render

export default script